import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=2b9041f5"
import script from "./wishlist.vue?vue&type=script&lang=ts"
export * from "./wishlist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/codebuild/output/src1993466134/src/acredo-website/components/Loading.vue').default,ElementHeadline: require('/codebuild/output/src1993466134/src/acredo-website/components/element/elementHeadline.vue').default,Breadcrumb: require('/codebuild/output/src1993466134/src/acredo-website/components/Breadcrumb.vue').default,MetaTitle: require('/codebuild/output/src1993466134/src/acredo-website/components/meta/MetaTitle.vue').default})
